import { jsx as s, jsxs as d } from "react/jsx-runtime";
import { useI18n as I } from "next-localization";
import { c as y } from "./clsx.OuTLNxxd.js";
import { S as r } from "./index.BhPhnmkE.js";
import { u as E } from "./use-formatted-date.6zMpaWWb.js";
import { RichText as m } from "@sitecore-jss/sitecore-jss-react";
const L = "8+", R = ({
  className: f = "",
  ucFacilityId: p,
  waitTimes: e,
  isLoading: u = !1,
  isShort: a = !1,
  translationOverride: n
}) => {
  var c, o;
  const h = I(), l = n || h.t, { time: i, tzAcronym: _ } = E(
    (c = e == null ? void 0 : e.data) == null ? void 0 : c.utc_last_modified,
    n
  );
  if (!l) return null;
  const t = (o = e == null ? void 0 : e.data) == null ? void 0 : o.hospitals.find(
    (q) => q.hospital_id === Number(p)
  ), x = t != null && t.waits.queue_length && (t == null ? void 0 : t.waits.queue_length) > 8 ? L : t == null ? void 0 : t.waits.queue_length, N = /* @__PURE__ */ s(
    m,
    {
      tag: "p",
      className: y(f, "my-1"),
      field: { value: l("Clockwise.PlaceInLine", { queue: x }) },
      editable: !1
    }
  ), g = /* @__PURE__ */ s(
    m,
    {
      tag: "p",
      className: "my-1",
      field: { value: l("Clockwise.UpdatedText", { time: i, timeZone: _ }) },
      editable: !1
    }
  );
  return u ? /* @__PURE__ */ d("div", { className: "my-2", children: [
    /* @__PURE__ */ s(r, { width: 150 }),
    a ? null : /* @__PURE__ */ s(r, { width: 175 })
  ] }) : /* @__PURE__ */ d("div", { className: "neu-text-caption", children: [
    N,
    a ? null : g
  ] });
};
export {
  L as P,
  R as a
};
